const employmentTypes = {
  employee: { id: 'employee', name: 'Employee' },
  contractor: { id: 'contractor', name: 'Contractor' },
  other: { id: 'other', name: 'Other' },
};

export default employmentTypes;
